<template>
  <!-- Kontener pojedynczego filtra: flexowy układ w wierszu -->
  <div class="filter d-flex"
       :class="isSG ? 'filter--no-border' : 'filter--border'">
    <!-- Etykieta filtra: nazwa przetłumaczona za pomocą $t -->
    <div class="name">{{ name }}</div>
    <!-- Symbol operatora (np. '=', '>='): wyświetlany po prawej stronie nazwy -->
    <span class="symbol">{{ symbol }}</span>
    <!-- Pole input:
         - name atrybut odpowiada kluczowi w store.filters
         - v-model.lazy wiąże wartość dwukierunkowo i zapisuje po zmianie
         - wartość trafia do store przez watcher w setup -->
    <input
      :name="fieldName"
      v-model.lazy="value"
      type="text"
    />
  </div>
</template>

<script>
import { watch, ref } from "vue";                       // Import reactive i watch z Composition API
import { useArchivalFiltersStore } from "../../stores/archivalFilters"; // Import store Pinia dla filtrów
import { isNOSG } from "@/config/appVersion";

export default {
  name: "SingleFilter",                                 // Nazwa komponentu
  props: ["name", "symbol", "fieldName", "isSG"],            // Właściwości przekazywane przez rodzica
  setup(props) {
    // Uzyskanie instancji store z filtrami archiwalnymi
    const filtersStore = useArchivalFiltersStore();

    if (
      props.fieldName === "similarity" &&
      isNOSG &&
      (filtersStore.filters[props.fieldName] === undefined || filtersStore.filters[props.fieldName] === "")
    ) {
      filtersStore.addItem(props.fieldName, 1);
    }
    
    // Inicjalizacja ref z wartością istniejącą w store lub pustym stringiem
    const value = ref(
      filtersStore.filters[props.fieldName] ?? ""
    );

    // Funkcja zapisująca nową wartość do store
    const saveValue = (newVal) => {
      filtersStore.addItem(props.fieldName, newVal);
    };

    // Obserwator zmian value: wywołuje saveValue przy każdej zmianie
    watch(value, (newVal) => {
      saveValue(newVal);
    });

    // Zwracamy ref i store do użycia w template
    return { value, filtersStore };
  },
};
</script>

<style scoped>
/* Styl podstawowy kontenera filtra */
.filter {
  padding-bottom: 5px;              /* odstęp na dole */
  margin-top: 5px;                  /* odstęp na górze */
}

/* warianty zależne od isSG */
.filter--border {
  border-bottom: 1px solid #b7b7b5;
}
.filter--no-border {
  border-bottom: none;
}

/* Styl symbolu operatora */
.symbol {
  padding: 5px 9px 5px 8px; /* padding: top right bottom left */
  width: 24px;               /* stała szerokość dla wyrównania */
  margin-right: 1px;         /* niewielki odstęp od input */
}

/* Styl pola input */
input {
  width: 124px;         /* szerokość pola */
  padding: 2px 10px;    /* wewnętrzny odstęp */
  text-align: center;   /* wyśrodkowanie tekstu */
  text-transform: uppercase; /* wielkie litery dla rejestracji */
}
</style>
